import type { ZudokuPlugin } from "zudoku";

export const SITE_URL = "https://docs.subbly.dev";

// Site-wide social tags. Each page sets its own <title> and description, and
// link scrapers (Slack, X, LinkedIn, iMessage) fall back to those for
// og:title and og:description, so only the tags that are the same on every
// page live here. Zudoku adds the canonical link from `canonicalUrlOrigin`.
export const seo = (): ZudokuPlugin => ({
  getHead: ({ location }) => (
    <>
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Subbly Developers" />
      <meta property="og:url" content={`${SITE_URL}${location.pathname}`} />
      <meta property="og:image" content={`${SITE_URL}/og-image.png`} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta
        property="og:image:alt"
        content="Build with Subbly's subscription API and SDK"
      />
      <meta name="twitter:card" content="summary_large_image" />
    </>
  ),
});
